import { useAccount } from 'wagmi'
import { parseUnits } from 'viem'
import { ADDRESSES, CHAIN_ID } from '@/lib/contracts'
import { useContractTx } from '@/hooks/useContractTx'
import { T } from '@/lib/theme'

// A "Get test tokens" strip, shown ONLY on the Sepolia testnet build (chain 11155111 with a deployed
// HorizonFaucet). One click each: mint mock USDC, drip HORIZON. Native ETH for gas + deposits comes from
// a public SepETH faucet (linked), since WETH is Sepolia's canonical WETH and the gateway wraps it.
const ZERO = '0x0000000000000000000000000000000000000000'
const IS_TESTNET = CHAIN_ID === 11155111
  && !!ADDRESSES.HORIZON_FAUCET && ADDRESSES.HORIZON_FAUCET.toLowerCase() !== ZERO

const USDC_ABI = [{ type: 'function', name: 'mint', stateMutability: 'nonpayable',
  inputs: [{ name: 'to', type: 'address' }, { name: 'amount', type: 'uint256' }], outputs: [] }]
const FAUCET_ABI = [{ type: 'function', name: 'drip', stateMutability: 'nonpayable', inputs: [], outputs: [] }]

export function TestnetFaucet() {
  const { address, isConnected } = useAccount()
  const tx = useContractTx()
  if (!IS_TESTNET) return null

  const mintUsdc = () => tx.run(
    { address: ADDRESSES.USDC, abi: USDC_ABI, functionName: 'mint', args: [address, parseUnits('10000', 6)] },
    { successMsg: '10,000 test USDC minted', pendingMsg: 'Minting USDC…' },
  )
  const dripHorizon = () => tx.run(
    { address: ADDRESSES.HORIZON_FAUCET, abi: FAUCET_ABI, functionName: 'drip', args: [] },
    { successMsg: '1,000 test HORIZON dripped', pendingMsg: 'Dripping HORIZON…' },
  )

  return (
    <div style={bar}>
      <span style={tag}>Sepolia Testnet</span>
      <span style={{ color: T.textDim, fontSize: T.fs.caption }}>Get test tokens</span>
      <button style={btn(!isConnected || tx.pending)} disabled={!isConnected || tx.pending} onClick={mintUsdc}>
        Mint 10,000 USDC
      </button>
      <button style={btn(!isConnected || tx.pending)} disabled={!isConnected || tx.pending} onClick={dripHorizon}>
        Drip 1,000 HORIZON
      </button>
      <a style={link} href="https://sepolia-faucet.pk910.de" target="_blank" rel="noreferrer">Need SepETH for gas? →</a>
      {!isConnected && <span style={{ color: T.textDim, fontSize: T.fs.caption }}>Connect a wallet to mint</span>}
    </div>
  )
}

const bar = {
  display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
  padding: '9px 20px', background: 'rgba(110,168,254,0.06)',
  borderBottom: `1px solid ${T.border}`, fontFamily: T.fontM,
}
const tag = {
  fontSize: 10, letterSpacing: 0.8, textTransform: 'uppercase', fontWeight: 700, color: T.accent,
  border: `1px solid ${T.accent}55`, borderRadius: 20, padding: '2px 9px',
}
const btn = (disabled) => ({
  fontFamily: T.fontM, fontSize: T.fs.caption, fontWeight: 600, color: disabled ? T.textDim : T.text,
  background: 'rgba(255,255,255,0.03)', border: `1px solid ${T.border}`, borderRadius: T.r.pill,
  padding: '6px 12px', cursor: disabled ? 'not-allowed' : 'pointer',
})
const link = { color: T.accent, fontSize: T.fs.caption, textDecoration: 'none', marginLeft: 'auto' }
